import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=56ad3e7c&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=56ad3e7c&prod&lang=stylus&scoped=true"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=56ad3e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ad3e7c",
  null
  
)

export default component.exports